<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('notice1.Add.HeadingNotice') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('notice1.Add.Title') }}</label>
                            <InputText :class="`${error.title ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('notice1.Add.Title')" id="title2" v-model="title"
                                @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.title }}</div>
                        </div>

                        <!-- <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('notice1.Add.CreatedDate') }}</label>
                            <Calendar :showIcon="true" :showButtonBar="true" v-model="create_date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                            <Calendar :class="`${error.create_date ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="create_date" dateFormat="yy/mm/dd" :placeholder="$t('notice1.Add.CreatedDate')" :manualInput="false" :max-date="new Date()" ></Calendar>
                            <div class="text-red">{{ error.create_date }}</div>
                        </div> -->
                    </div>
                </div>
                <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                    <label for="title2">{{ $t('notice1.edit.ViewDescription') }}</label><br>
                    <div class="textbox" :style="error?.description ? 'border: 1px solid red' : ''">
                        <RichEditor v-model="add_description" :set-content="description" :placeholder="$t('Service.Edit.Desc')"/>
                        <!-- <Quill-Editor style="height: 200px" v-model:content="description" ref="myQuillEditor"
                            :options="editorOption" contentType="html" /> -->
                    </div>
                    <div class="text-red">{{ error.description }}</div>
                </div>
            </div>
            <br><br>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <Button :label="$t('notice1.Add.Save')" class="p-button p-button p-mr-2 p-mb-2" @click="addnotice"
                    style="margin-top: -30px;background: black; color: white;" icon="pi pi-check"
                    iconPos="left"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('notice1.Add.Back')" class="p-button p-button-outlined p-button p-mr-2 p-mb-2"
                    @click="$router.go(-1)" style="background: white; color: black; margin-top: -30px" icon="pi pi-replay" iconPos="left"></Button>
            </div>
        </form>
    </div>
</template>

<script>
// import { QuillEditor } from '@vueup/vue-quill';
import NoticeService from '../../service/API/NoticeService';
import axios from 'axios';
import validateCreateNotice from '../../validations/notice/validateCreateNotice';
import RichEditor from '../../components/RichEditor.vue';
// import moment from 'moment';
export default {
    name: 'AddNotice',
    components: {
        // QuillEditor,
        RichEditor
    },
    data() {
        return {
            modelname: '',
            title: '',
            description: '',
            create_date: '',
            add_description:'',
            formData: new FormData(),
            error: {}
        };
    },
    created() {
        this.noticeService = new NoticeService();
    },

    methods: {
        extractTextFromHTML(html) {
            const element = document.createElement('div');
            element.innerHTML = html;

            // Recursive function to traverse the DOM tree
            function traverse(node, result = '') {
                const children = node.childNodes;

                for (let i = 0; i < children.length; i++) {
                    const child = children[i];

                    if (child.nodeType === Node.TEXT_NODE) {
                        result += child.textContent;
                    } else if (child.nodeType === Node.ELEMENT_NODE) {
                        if (child.style.display !== 'none') {
                            result += traverse(child);
                        }
                    }
                }

                return result;
            }

            return traverse(element);
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        addnotice() {
            let vcheckData = {
                title: this.title,
                description:this.extractTextFromHTML(this.add_description).trim(),
                // create_date: this.create_date,
            };
            const { isInvalid, error } = validateCreateNotice(vcheckData);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                this.error = '';
                console.log(this.modelname);
                return axios.post('api/v1/admin/notice/add', { title: this.title, description: this.add_description, created_date: this.addDay(new Date()) }).then(() => {
                    // alert('Tag added successfully.');

                    this.$router.push({ name: 'Notice' });
                    console.log(this.create_date);
                    console.log(this.description);
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '확인.', detail: '알림이 성공적으로 추가되었습니다.', life: 3000 });
                    }, 500);
                });
                // this.noticeService.addNotice(title : this.title,  this.modelname, this.create_date,).then(() => {
                //     this.$router.push({ name: 'NoticeList' });
                // });
            }
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: red;
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.ql-editor {
    height: 200px;
}
.card{
    height: 100%;
}
</style>
